<template>
    <Modal :close_button="true" :size="'modal-lg'" mid="account-sessions">
        <template v-slot:header>
            {{$t('management_console.account.sessions_modal_title')}}
        </template>
        <template v-slot:body>
            <div v-if="sessions.length > 0" class="table-responsive rounded border">
                <table class="table table-light table-hover small text-gray-700 mb-0">
                    <thead>
                        <tr class="align-middle">
                            <th scope="col" class="text-gray-600 text-center">IP</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.members.browser')}}</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.common.created_at')}}</th>
                            <th scope="col" class="text-gray-600 text-center">{{$t('management_console.common.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody class="border-top-0">
                        <tr v-for="session in sessions" :key="session.id" class="align-middle">
                            <td><p class="m-0 text-center text-nowrap">{{session.ip}}</p></td>
                            <td><p class="m-0 text-center">{{$filters.ParseUserAgent(session.ua)}}</p></td>
                            <td><p class="m-0 text-center text-nowrap">{{$filters.PrettyDate(session.created_at)}}</p></td>
                            <td class="text-center text-nowrap">
                                <span v-if="session.current" class="text-gray-600">
                                    {{$t('management_console.account.current_session')}}
                                </span>
                                <button
                                v-else
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                :disabled="deleting_session_id !== null"
                                @click="delete_session(session)">
                                    <span v-if="deleting_session_id === session.id" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                    {{$t('controls.remove')}}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </Modal>
</template>

<script>
import SessionStore from '@/common/store/session.js'

export default {
    data: function () {
        return {
            deleting_session_id: null
        }
    },
    computed: {
        sessions: function () {
            return Array.isArray(SessionStore.state.sessions) ? SessionStore.state.sessions : []
        }
    },
    methods: {
        delete_session: async function (session) {
            if (!session || session.current || this.deleting_session_id !== null) {
                return
            }

            this.deleting_session_id = session.id
            try {
                const response = await SessionStore.dispatch('DELETE_SESSION', {
                    session_id: session.id
                })

                if (response && response.status === 0) {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.operation_success'),
                        msg: this.$t('management_console.account.session_deleted'),
                        level: 'success'
                    })
                } else {
                    this.$bus.$emit('Notification/show', {
                        title: this.$t('notifications.something_went_wrong'),
                        msg: this.$t('notifications.please_retry_the_operation_or_refresh'),
                        level: 'danger'
                    })
                }
            } finally {
                this.deleting_session_id = null
            }
        }
    }
}
</script>
